/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Coinvestment_Description1Inputs */

const en_settings_coinvestment_description1 = /** @type {(inputs: Settings_Coinvestment_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configure email templates and settings for co-investment opportunities.`)
};

/**
* | output |
* | --- |
* | "Configure email templates and settings for co-investment opportunities." |
*
* @param {Settings_Coinvestment_Description1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_coinvestment_description1 = /** @type {((inputs?: Settings_Coinvestment_Description1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Coinvestment_Description1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_coinvestment_description1(inputs)
});
export { settings_coinvestment_description1 as "settings_coInvestment_description" }